import { Phone, MessageCircleMore } from "lucide-react";
import useContactForm from "./../../hook/useContactForm";
import sendViaWhatsApp from "./../../utils/sendViaWhatsApp";

const WHATSAPP_NUMBER = "+918178052636";
const PHONE_DISPLAY = "8178052636";

const BookContact = () => {
    const { formData, errors, handleChange, handleSubmit } = useContactForm();

    const submitForm = (data) => {
        console.log("Form Data:", data);
        alert("Redirecting to WhatsApp!");
        sendViaWhatsApp(data);
    };

    return (
        <section
            id="contact"
            className="min-h-screen bg-gray-900 text-white py-20 px-4 relative overflow-hidden"
        >
            <div className="relative z-10 max-w-5xl mx-auto">
                <h2 className="text-3xl text-yellow-400 font-bold text-center mb-6">
                    Schedule A Free Home Service Visit
                </h2>
                <p className="text-center text-lg text-gray-300 mb-4">
                    Just give us a call, confirm your appointment, and our executive will
                    visit your location within 1 hour.
                </p>
                <p className="text-center text-lg text-gray-300 mb-4">
                    Please share your details, and our
                    support team will call you back shortly.
                </p>

                <div className="flex flex-col items-center gap-3 mb-8 text-center">
                    <p className="text-xl font-semibold text-yellow-400 flex items-center gap-2">
                        <Phone size={20} /> Call Us:{" "}
                        <span className="ml-1">{PHONE_DISPLAY}</span>
                    </p>
                    <a
                        href={`https://wa.me/${WHATSAPP_NUMBER}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium px-5 py-2 rounded-full transition duration-200"
                    >
                        <MessageCircleMore size={18} /> Chat on WhatsApp
                    </a>
                </div>

                <div className="relative w-full bg-white/10 backdrop-blur-md rounded-2xl p-4 sm:p-6 md:p-8 shadow-2xl text-white">
                    <form onSubmit={handleSubmit(submitForm)} className="space-y-6">
                        <div>
                            <label className="block mb-2">
                                Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`w-full p-3 rounded bg-gray-950 text-white focus:ring-2 ${errors.name ? "ring-red-500" : "focus:ring-yellow-400"
                                    }`}
                                placeholder="Your Name"
                            />
                            {errors.name && (
                                <p className="text-red-400 text-sm mt-1">{errors.name}</p>
                            )}
                        </div>

                        <div>
                            <label className="block mb-2">
                                Phone No. <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                className={`w-full p-3 rounded bg-gray-950 text-white focus:ring-2 ${errors.phone ? "ring-red-500" : "focus:ring-yellow-400"
                                    }`}
                                placeholder="Your Phone Number"
                            />
                            {errors.phone && (
                                <p className="text-red-400 text-sm mt-1">{errors.phone}</p>
                            )}
                        </div>

                        <div>
                            <label className="block mb-2">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full p-3 rounded bg-gray-950 text-white focus:ring-2 focus:ring-yellow-400"
                                placeholder="Your Email"
                            />
                        </div>

                        <div>
                            <label className="block mb-2">Message</label>
                            <textarea
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                className="w-full p-3 rounded bg-gray-950 text-white focus:ring-2 focus:ring-yellow-400"
                                placeholder="Your Message"
                                rows="5"
                            />
                        </div>

                        <button
                            type="submit"
                            className="bg-yellow-400 hover:bg-yellow-300 text-black font-bold py-3 px-6 rounded"
                        >
                            Send Message via WhatsApp
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default BookContact;
